import React from "react";
import BtnDisableTooltip from "./teamModule/component/BtnDisableTooltip";

const EmptyStateComp = ({
   headerText,
   description,
   btnText = false,
   className,
   disabled,
   onClick = () => {},
   src = "",
   btnClassName = "",
   checkMemberRole = true,
   emptyCardCondition = false,
   recentUpdatesEmpty = false,
   notesEmptyCaption = "",
   imgClass = "",
}) => {
   return (
      <div
         style={recentUpdatesEmpty ? { height: "250px", width: "280px" } : { height: "100%" }}
         className={`d-flex ${emptyCardCondition ? "mt-3 mx-1 bg-white" : ""} ${
            recentUpdatesEmpty ? " bg-white" : ""
         } flex-center justify-content-center flex-column align-items-center gap-5 ${className}`}
      >
         <div className="no-patients-svg">
            <img src={src} alt={headerText} width={100} className={imgClass} />
         </div>
         <h2 className="no-content-text mt-3">{headerText}</h2>
         {description && (
            <h4
               className={`no-content-description mt-4 text-center desc-width ${
                  recentUpdatesEmpty && "text-dark text-xmedium text-400 text-pre-wrap"
               } ${notesEmptyCaption}  `}
            >
               {description}
            </h4>
         )}
         {btnText && (
            <button
               className={`btn-sm btn-default text-white font-weight-bold text-small round-border-m flex-center mx-3 mt-4 ${btnClassName}`}
               disabled={disabled}
               onClick={onClick}
            >
               {btnText}
               <BtnDisableTooltip checkMemberRole={checkMemberRole} className="tooltiptext" />
            </button>
         )}
      </div>
   );
};

export default EmptyStateComp;
